export default {
  STATUS: {
    REQUESTED: { KEY: 0, VALUE: 'REQUISITADO', color: '#333333' },
    APPROVED: { KEY: 1, VALUE: 'APROVADO', color: '#1BB76C' },
    DECLINED: { KEY: 2, VALUE: 'REPROVADO', color: '#A62A2A' },
  },
  USER_PROFILE_STATUS: {
    INACTIVE: { KEY: 0, VALUE: 'INATIVO' },
    ACTIVE: { KEY: 1, VALUE: 'ATIVO' },
    BLOCKED: { KEY: 2, VALUE: 'BLOQUEADO' },
    EXPIRED: { KEY: 3, VALUE: 'EXPIRADO' },
  },

  USER_PROFILE_ACTION: [
    { KEY: 'update_user_profile_request_data', VALUE: 'ATUALIZAÇÃO DOS DADOS DA SOLICITAÇÃO DE PERFIL' },
    { KEY: 'update_user_profile_request_status', VALUE: 'ATUALIZAÇÃO DO STATUS DA SOLICITAÇÃO DE PERFIL' },
    { KEY: 'block_facial_user_profile', VALUE: 'BLOQUEIO FACIAL DO PERFIL' },
    { KEY: 'vt_inactivate_with_balance', VALUE: 'INATIVAÇÃO VIA SALDO VT' },
    { KEY: 'vt_request_user_profile', VALUE: 'SOLICITAÇÃO DE PERFIL VIA VT' },
    { KEY: 'vt_user_profile_inactivate', VALUE: 'INATIVAÇÃO DO PERFIL VIA VT' },
    { KEY: 'school_user_profile_inactivate', VALUE: 'INATIVAÇÃO DO PERFIL VIA ESCOLA' },
    { KEY: 'company_user_profile_inactivate', VALUE: 'INATIVAÇÃO DO PERFIL VIA EMPRESA' },
    { KEY: 'toggle_user_profile_status', VALUE: 'ATUALIZAÇÃO DO STATUS DO PERFIL VIA BDOS' },
    { KEY: 'update_profile_expiration', VALUE: 'ATUALIZAÇÃO DA EXPIRAÇÃO DO PERFIL' },
    { KEY: 'update_profile_expiration_auto', VALUE: 'ATUALIZAÇÃO AUTOMÁTICA DA EXPIRAÇÃO DO PERFIL' },
    { KEY: 'UNBLOCK_USER_PROFILE_AUTO', VALUE: 'DESBLOQUEIO AUTOMÁTICO DO PERFIL' },
    { KEY: 'request_user_profile', VALUE: 'SOLICITAÇÃO DE PERFIL' },
    { KEY: 'update_user_profile_data', VALUE: 'ATUALIZAÇÃO DE DADOS DO PERFIL' },
  ],

  TYPE: {
    USER_REQUESTED: { KEY: 0, VALUE: 'PEDIDO POR USUARIO' },
    OPERATOR_REQUESTED: { KEY: 1, VALUE: 'PEDIDO POR OPERADOR' },
    SCHOOL_REQUESTED: { KEY: 2, VALUE: 'PEDIDO PELA ESCOLA' },
  },
  PARAMETER_REASON: {
    WRONG_PHOTO: 0,
    BAD_QUALITY_PHOTO: 1,
    INVALID_DOCUMENT: 2,
    INVALID_PHOTO: 3,
    OHTER: 4,
  },
  XML_STATUS: [
    { KEY: 0, VALUE: 'Carregando...', COLOR: '#000000' },
    { KEY: 1, VALUE: 'Sucesso', COLOR: '#22D76A' },
    { KEY: 2, VALUE: 'Falha', COLOR: '#E22020', ERROR: true },
    { KEY: 3, VALUE: 'Reprocessando...', COLOR: '#000000' },
  ],
  XML_STATUS_KEY: {
    LOADING: 'Carregando...',
    SUCCESS: 'Sucesso',
    ERROR: 'Falha',
    PROCESSING: 'Reprocessando...',
  },
  ERRO_VALIDATE: [
    { KEY: 'any.required', VALUE: 'Campo ausente' },
    { KEY: 'any.empty', VALUE: 'Preenchimento obrigatório' },
    { KEY: 'string.cpf', VALUE: 'CPF inválido' },
    { KEY: 'string.phone', VALUE: 'Telefone inválido (padrão E.164)' },
    { KEY: 'any.unique', VALUE: 'Cadastro Duplicado' },
    {
      ALLOW_ONLY: true,
      KEY: 'any.allowOnly',
      VALUE: 'Permitido apenas os valores ',
    },
    {
      STRING_CARD: true,
      KEY: 'string.card',
      PART_1: 'Cartão com número',
      PART_2: 'não foi emitido ou não está registrado no sistema',
    },
    {
      STRING_CARD_DIFFERENT_USER: true,
      KEY: 'string.differentusercard',
      PART_1: 'Cartão com número',
      PART_2: 'está vinculado a outro usuário',
    },
    {
      STRING_LINE: true,
      KEY: 'string.line',
      PART_1: 'Linha com prefixo',
      PART_2: 'não está registrado no sistema',
      INCTIVE_LINE_PART_2: 'está inativa no sistema',
      INCTIVE_LINE_KEY: '.inactive',
    },
    {
      STRING_SCHOOL: true,
      KEY: 'string.school',
      PART_1: 'Escola com código',
      PART_2: 'não está registrado no sistema',
    },
  ],
  ERROR_RESULT: [
    { KEY: 'external.import.validation', TYPE: 'table' },
    {
      KEY: 'external.import.missingdata',
      TYPE: 'text',
      CONTENT: [
        {
          KEY: 'inexistentLines',
          VALUE:
            'As linhas listadas abaixo precisam ser criadas no sistema antes da importação:',
        },
        {
          KEY: 'inexistentSchools',
          VALUE:
            'As escolas listadas abaixo precisam ser criadas no sistema antes da importação:',
        },
        {
          CARD: true,
          KEY: 'inexistentCards',
          VALUE:
            'Os cartões listados abaixo precisam ser criado no sistema antes da importação:',
        },
      ],
    },
  ],
  ERROR_TYPE: [
    { KEY: 'external.import.missingdata', COD: 400 },
    { KEY: 'external.import.validation', COD: 400 },
  ],
  DOCUMENT_TYPE: [
    {
      KEY: 'DOCUMENT_CPF',
      VALUE: 'CPF',
      TYPE: 0,
    },
    {
      KEY: 'DOCUMENT_RG',
      VALUE: 'RG',
      TYPE: 1,
    },
    {
      KEY: 'BIRTHDATE',
      VALUE: 'Data de aniversario',
      TYPE: 2,
    },
    {
      KEY: 'EMAIL',
      VALUE: 'E-mail',
      TYPE: 3,
    },
    {
      KEY: 'PHONE',
      VALUE: 'Telefone',
      TYPE: 4,
    },
    {
      KEY: 'CEPS',
      VALUE: 'Cep',
      TYPE: 5,
    },
    {
      KEY: 'GESTATION',
      VALUE: 'Semanas de gestação',
      TYPE: 6,
    },
    {
      KEY: 'IMC',
      VALUE: 'Imc',
      TYPE: 7,
    },
    {
      KEY: 'NIS_DOCUMENT',
      VALUE: 'Documento NIS',
      TYPE: 8,
    },
    {
      KEY: 'CID',
      VALUE: 'Número CID',
      TYPE: 9,
    },
    {
      KEY: 'STUDENT_REGISTRY',
      VALUE: 'Comprovante de Matrícula',
      TYPE: 10,
    },
    {
      KEY: 'MOTHER_FILIATION',
      VALUE: 'Filiação (Mãe)',
      TYPE: 11,
    },
    {
      KEY: 'FATHER_FILIATION',
      VALUE: 'Filiação (Pai)',
      TYPE: 12,
    },
    {
      KEY: 'INSS',
      VALUE: 'INSS',
      TYPE: 13,
    },
    {
      KEY: 'PROOF_OF_INCOME',
      VALUE: 'Comprovante de Renda',
      TYPE: 14,
    },
    {
      KEY: 'MOTHER_DOCUMENT',
      VALUE: 'Documento da Mãe',
      TYPE: 15,
    },
    {
      KEY: 'FATHER_DOCUMENT',
      VALUE: 'Documento da Pai',
      TYPE: 16,
    },
    {
      KEY: 'SEDS',
      VALUE: 'SEDS',
      TYPE: 17,
    },
    {
      KEY: 'ADDITIONAL_DOCUMENT',
      VALUE: 'Documento adicional',
      TYPE: 18,
    },
    {
      KEY: 'MERGE_TEMP',
      VALUE: 'Documento Pendente',
      TYPE: 99,
    },
  ],

  RESOURCES_TYPE: [
    {
      KEY: 'DOCUMENT_CPF',
      VALUE: 'CPF',
      TYPE: 0,
    },
    {
      KEY: 'DOCUMENT_RG',
      VALUE: 'RG',
      TYPE: 1,
    },
    {
      KEY: 'BIRTHDATE',
      VALUE: 'Data de aniversario',
      TYPE: 2,
    },
    {
      KEY: 'EMAIL',
      VALUE: 'E-mail',
      TYPE: 3,
    },
    {
      KEY: 'PHONE',
      VALUE: 'Telefone',
      TYPE: 4,
    },
    {
      KEY: 'CEPS',
      VALUE: 'Cep',
      TYPE: 5,
    },
    {
      KEY: 'GESTATION',
      VALUE: 'Semanas de gestação',
      TYPE: 6,
    },
    {
      KEY: 'IMC',
      VALUE: 'Imc',
      TYPE: 7,
    },
    {
      KEY: 'NIS_DOCUMENT',
      VALUE: 'Documento NIS',
      TYPE: 8,
    },
    {
      KEY: 'CID',
      VALUE: 'Número CID',
      TYPE: 9,
    },
    {
      KEY: 'FULLNAME',
      VALUE: 'Nome Completo',
      TYPE: 10,
    },
    {
      KEY: 'PICTURE_DOCUMENT',
      VALUE: 'Foto do Documento',
      TYPE: 11,
    },
    {
      KEY: 'USER_PHOTO',
      VALUE: 'Foto do Usuário',
      TYPE: 12,
    },
    {
      KEY: 'MOTHER_NAME',
      VALUE: 'Nome da Mãe',
      TYPE: 13,
    },
    {
      KEY: 'GENRE',
      VALUE: 'Gênero',
      TYPE: 14,
    },
    {
      KEY: 'ETHNICITY',
      VALUE: 'Etinia',
      TYPE: 15,
    },
    {
      KEY: 'EMPLOYER',
      VALUE: 'Empregador',
      TYPE: 16,
    },
    {
      KEY: 'EDUCATIONAL',
      VALUE: 'Instituição de Ensino',
      TYPE: 17,
    },
    {
      KEY: 'NIS_DOCUMENT',
      VALUE: 'NIS',
      TYPE: 18,
    },
    {
      KEY: 'IMC',
      VALUE: 'IMC',
      TYPE: 19,
    },
    {
      KEY: 'CID',
      VALUE: 'CEP',
      TYPE: 20,
    },
    {
      KEY: 'COMPANION',
      VALUE: 'Acompanhante',
      TYPE: 21,
    },
    {
      KEY: 'ETHNICITIES',
      VALUE: 'Raça',
      TYPE: 22,
    },
    {
      KEY: 'GENRES',
      VALUE: 'Gênero',
      TYPE: 23,
    },
    {
      KEY: 'EMPLOYEE_FUNCTION',
      VALUE: 'Função',
      TYPE: 24,
    },
    {
      KEY: 'EMPLOYEE_ENTER_DATE',
      VALUE: 'Data de entrada',
      TYPE: 25,
    },
    {
      KEY: 'INSS_DOCUMENT',
      VALUE: 'Documento INSS',
      TYPE: 26,
    },
    {
      KEY: 'CIDS',
      VALUE: 'Número CID',
      TYPE: 27,
    },
    {
      KEY: 'CIDS',
      VALUE: 'Número CID',
      TYPE: 28,
    },
    {
      KEY: 'ALLOWED_LINES',
      VALUE: 'Linhas',
      TYPE: 29,
    },
    {
      KEY: 'ALLOWED_DAYS',
      VALUE: 'Dias',
      TYPE: 30,
    },
    {
      KEY: 'EDUCATIONAL_DOCUMENT',
      VALUE: 'Comprovante de Matricula',
      TYPE: 31,
    },
    {
      KEY: 'MOTHER_NAME',
      VALUE: 'Nome da mãe',
      TYPE: 32,
    },
    {
      KEY: 'FATHER_NAME',
      VALUE: 'Nome do pai',
      TYPE: 33,
    },
    {
      KEY: 'MOTHER_DOCUMENT',
      VALUE: 'Documento da mãe',
      TYPE: 34,
    },
    {
      KEY: 'FATHER_DOCUMENT',
      VALUE: 'Documento do pai',
      TYPE: 35,
    },
    {
      KEY: 'ALLOWED_DEVICE',
      VALUE: 'Dispositivo',
      TYPE: 36,
    },
    {
      KEY: 'SEDS_DOCUMENT',
      VALUE: 'Documento SEDS',
      TYPE: 37,
    },
    {
      KEY: 'ADDITIONAL_DOCUMENTS',
      VALUE: 'Documento adicional',
      TYPE: 38,
    },
    {
      KEY: 'DOCUMENT_PASSPORT',
      VALUE: 'Passaporte',
      TYPE: 39,
    },

  ],
  DAILY_BLOCK_LIMITATION: 'DAILY_BLOCK_LIMITATION',
  COAUTHORSHIP_LIMITATION: 'COAUTHORSHIP_LIMITATION',
  COAUTHORSHIP_DEVICE: 'COAUTHORSHIP_DEVICE',
  EDUCATIONAL: {
    VALUE: ['Instituição de Ensino', 'Curso'],
    TYPE: 17,
  },
  ADDITIONAL_DOCUMENTS: {
    KEY: 'ADDITIONAL_DOCUMENTS',
    VALUE: 'Documento adicional',
    TYPE: 38,
  },
  ALLOWED_DEVICE: {
    KEY: 'ALLOWED_DEVICE',
    VALUE: 'Dispositivo',
    TYPE: 36,
  },
};
